import React from 'react'
import { Route } from 'react-router-dom'
import { auth } from '../../../services/util/auth.service'
import PatioMenu from './PatioMenu/PatioMenu'
import CadastroBalanca from './Balanca/CadastroBalanca'
import MovimentacoesBalanca from './BalancaMovimentacao/MovimentacoesBalanca'
import CadastroTomada from './Tomada/CadastroTomada'
import UtilizacoesTomada from './TomadaUtilizacao/UtilizacoesTomada'

export default function Patio() {
  return (
    <>
      <Route path="/main/patio/menu" render={() => auth(<PatioMenu />)} />
      <Route path="/main/patio/cadastro-balanca" render={() => auth(<CadastroBalanca />, 130)} />
      <Route
        path="/main/patio/movimentacoes-balanca"
        render={() => auth(<MovimentacoesBalanca />, 131)}
      />
      <Route path="/main/patio/cadastro-tomada" render={() => auth(<CadastroTomada />, 132)} />
      <Route
        path="/main/patio/utilizacao-tomadas"
        render={() => auth(<UtilizacoesTomada />, 133)}
      />
    </>
  )
}
